import { Routes } from '@angular/router';
import { LayoutComponent } from './admin/layout/layout.component';
import { Adminroutes } from './admin/admin.routes';
import { LoginComponent } from './auth/login/login.component';
import { PrimeiroLoginComponent } from './auth/primeiro-login/primeiro-login.component';
import { AuthGuard } from './auth/guard/auth.guard';
import { GuestGuard } from './auth/guard/guest.guard';

export const routes: Routes = [
    // A rota protegida decide se restaura a sessão ou envia para o login.
    {
        path: '',
        redirectTo: 'admin',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [GuestGuard]
    },
    {
        path: 'primeiro-login',
        component: PrimeiroLoginComponent
    },
    // bloco do admin
    {
        path: 'admin',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        data: {
            breadcrumb: 'Admin'
        },
        children: [
            { path: '', redirectTo: 'dashboards', pathMatch: 'full' },
            ...Adminroutes
        ]
    },

    // fallback
    { path: '**', redirectTo: 'login' }
];
